import { View } from "@react-pdf/renderer";
import { ResumePDFSkillsTwoColumn } from "components/Resume/ResumePDF/common";
import { TemplateThreeEnhancedSection } from "./common";
import { spacing, styles } from "components/Resume/ResumePDF/styles";
import type { ResumeSkills } from "lib/redux/types";

export const Skills = ({
  heading,
  skills,
}: {
  heading: string;
  skills: ResumeSkills;
}) => {
  const { descriptions } = skills;

  return (
    <TemplateThreeEnhancedSection heading={heading}>
      <View wrap={false} style={{ ...styles.flexRow, gap: spacing[1.5] }}>
        <View style={{ width: "21%" }}></View>
        <View style={{ width: "79%" }}>
          <ResumePDFSkillsTwoColumn items={descriptions} />
        </View>
      </View>
    </TemplateThreeEnhancedSection>
  );
};
